import { render, staticRenderFns } from "./ExpandPocDialog.vue?vue&type=template&id=61bda628&scoped=true&"
import script from "./ExpandPocDialog.vue?vue&type=script&lang=js&"
export * from "./ExpandPocDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExpandPocDialog.vue?vue&type=style&index=0&id=61bda628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bda628",
  null
  
)

export default component.exports